import React from 'react';
import { Menu } from '@headlessui/react';
import classNames from 'classnames';

type DropdownItemProps = {
  icon?: React.ReactNode;
  disabled?: boolean;
  variant?: 'default' | 'danger';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const DropdownItem: React.FC<DropdownItemProps> = ({
  children,
  icon,
  disabled,
  variant = 'default',
  onClick,
}) => {
  return (
    <Menu.Item disabled={disabled}>
      {({ active }) => (
        <button
          type="button"
          className={classNames(
            'w-full px-3 py-2 flex items-center text-left whitespace-nowrap focus:outline-none',
            { 'bg-gray-100': active },
            { 'text-gray-400 cursor-default': disabled },
            variant === 'danger' && [
              'text-red-500',
              { 'text-red-700': active },
            ],
            variant === 'default' && [{ 'text-gray-900': active }]
          )}
          disabled={disabled}
          onClick={onClick}
        >
          {icon ? (
            <div className="mr-3 text-base" aria-hidden={true}>
              {icon}
            </div>
          ) : null}
          {children}
        </button>
      )}
    </Menu.Item>
  );
};
